/**
 * @generated SignedSource<<2a8cb8796445f852713ec8cc019cf5b7>>
 * @relayHash 02d4124590c433b0c9de4e4aa3c91197
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c6ae4e96640fd92369f5f9abdc58c10451a3c13851e720cd775c3f1b446b2651

import type { ConcreteRequest } from 'relay-runtime';
export type JiraNavigationItemTypeKey = "AGENT_CONTEXT" | "AI_PLANNING" | "APP" | "APPROVALS" | "APPS" | "ARCHIVED_ISSUES" | "ATTACHMENTS" | "BACKLOG" | "BOARD" | "CALENDAR" | "CAPACITY" | "CODE" | "COMPONENTS" | "CUSTOMER_SUPPORT" | "DEPENDENCIES" | "DEPLOYMENTS" | "DEVELOPMENT" | "FORMS" | "GET_STARTED" | "GOALS" | "INBOX" | "INCIDENTS" | "ISSUES" | "KNOWLEDGE" | "LIST" | "ON_CALL" | "PAGES" | "PLAN_CALENDAR" | "PLAN_DEPENDENCIES" | "PLAN_PROGRAM" | "PLAN_RELEASES" | "PLAN_SUMMARY" | "PLAN_TEAMS" | "PLAN_TIMELINE" | "PROGRAM" | "QUEUE" | "RELEASES" | "REPORTS" | "REQUESTS" | "SECURITY" | "SHORTCUTS" | "SUMMARY" | "TEAMS" | "TIMELINE" | "%future added value";
export type JiraContainerNavigationQueryInput = {
  projectKeyQuery?: JiraContainerNavigationByProjectKeyQueryInput | null;
  scopeId?: string | null;
};
export type JiraContainerNavigationByProjectKeyQueryInput = {
  cloudId: string;
  projectKey: string;
};
export type SettingsContainerContentQuery$variables = {
  first: number;
  input: JiraContainerNavigationQueryInput;
};
export type SettingsContainerContentQuery$data = {
  readonly jira: {
    readonly containerNavigation: {
      readonly __typename: "JiraContainerNavigation";
      readonly navigationItems: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly typeKey: JiraNavigationItemTypeKey | null;
          };
        } | null>;
        readonly errors: ReadonlyArray<{
          readonly extensions: ReadonlyArray<{
            readonly statusCode: number | null;
          }> | null;
          readonly message: string | null;
        }> | null;
      } | null;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly statusCode: number | null;
      }> | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type SettingsContainerContentQuery = {
  response: SettingsContainerContentQuery$data;
  variables: SettingsContainerContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v8 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v7/*: any*/)
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = [
  (v6/*: any*/),
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v7/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SettingsContainerContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "containerNavigation",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "args": (v4/*: any*/),
                        "concreteType": "JiraNavigationItemConnection",
                        "kind": "LinkedField",
                        "name": "navigationItems",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": {
                              "concreteType": "JiraNavigationItemEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "RequiredField",
                                  "field": {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/)
                                    ]
                                  },
                                  "action": "THROW"
                                }
                              ]
                            },
                            "action": "THROW"
                          },
                          {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v8/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "JiraContainerNavigation"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v8/*: any*/)
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SettingsContainerContentQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "containerNavigation",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v4/*: any*/),
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "navigationItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v5/*: any*/),
                              (v9/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": (v10/*: any*/)
                      }
                    ]
                  }
                ],
                "type": "JiraContainerNavigation"
              },
              {
                "kind": "InlineFragment",
                "selections": (v10/*: any*/),
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c6ae4e96640fd92369f5f9abdc58c10451a3c13851e720cd775c3f1b446b2651",
    "metadata": {},
    "name": "SettingsContainerContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f661aeee5eaa80513a6a6aee41ee162d";

export default node;
